import React from 'react';
import { Typography, Box } from '@mui/material';
import { useLocation } from 'react-router-dom';
import { ModelType } from '@/types/colabfold';

interface JobFormHeaderProps {
  modelType: ModelType;
}

const JobFormHeader: React.FC<JobFormHeaderProps> = ({ modelType }) => {
  const location = useLocation();
  
  const getModelTypeLabel = (type: ModelType) => {
    switch (type) {
      case ModelType.COLABFOLD:
        return 'ColabFold';
      case ModelType.RFDIFFUSION:
        return 'RF Diffusion';
      case ModelType.ESMIF:
        return 'ESM-IF';
      default:
        return type;
    }
  };

  return (
    <Box mb={3}>
      <Typography variant="h4" gutterBottom>
        New {getModelTypeLabel(modelType)} Job
      </Typography>
      {location.state?.folderId && (
        <Typography variant="subtitle1" color="textSecondary">
          Creating job in folder: {location.state.folderName || 'Unnamed Folder'}
        </Typography>
      )}
    </Box>
  );
};

export default JobFormHeader; 